import React, { useState, useEffect } from "react";
import {
  Form,
  DatePicker,
  Radio,
  Row,
  Col,
  Select,
  Input,
  Button,
  Table,
  message,
} from "antd";
import moment from "moment";
import {
  getTaxEnterpriseList,
  getRelevanceCompany,
  getPersonalTaxList,
  exportPersonalTaxList,
} from "../../../../api/api";
const { RangePicker } = DatePicker;
const { Option } = Select;

const itemStyle = { width: "300px", marginRight: "15px" };
const labelStyleObj = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

const Current = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [taxEnterpriseCodeList, settaxEnterpriseCodeList] = useState([]);
  const [companyCodeList, setcompanyCodeList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `共 ${total} 条`,
  });

  useEffect(() => {
    getTaxEnterpriseListall();
    getRelevanceCompanyall();
    getPersonalTaxListall();
  }, []);
  // 获取所有结算企业
  const getTaxEnterpriseListall = async () => {
    const res = await getTaxEnterpriseList();
    if (res.data.success) {
      settaxEnterpriseCodeList(res.data.data);
    }
  };
  // 获取所有企业
  const getRelevanceCompanyall = async () => {
    const res = await getRelevanceCompany();
    if (res) {
      setcompanyCodeList(res);
    }
  };
  // 获取列表
  const getPersonalTaxListall = async (pageParams = {}) => {
    const { companyCodeList, taxEnterpriseCodeList, keyword, rangeDate } =
      form.getFieldsValue();
    setLoading(true);
    const params = {
      companyCodeList,
      taxEnterpriseCodeList,
      keyword,
      beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
      endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
      pageNum: pageParams.pageNum || pagination.current,
      pageSize: pageParams.pageSize || pagination.pageSize,
    };
    try {
      const { data: res } = await getPersonalTaxList(params);
      if (!res.success) return message.error(res.retMsg);
      setTableData(res.data.list);
      setPagination({
        ...pagination,
        current: pageParams.pageNum || pagination.current,
        pageSize: pageParams.pageSize || pagination.pageSize,
        total: res.data.totalCount,
      });
    } catch (error) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  };
  // 分页变化处理
  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
    getPersonalTaxListall({
      pageNum: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };
  // 重置
  const resetForm = () => {
    form.resetFields();
  };
  // 查询
  const submit = () => {
    // 查询时重置到第一页
    setPagination({
      ...pagination,
      current: 1,
    });
    getPersonalTaxListall({ pageNum: 1 });
  };
  // 导出
  const exportExcel = async () => {
    try {
      const { companyCodeList, taxEnterpriseCodeList, keywordq, rangeDate } =
        form.getFieldsValue();
      const params = {
        companyCodeList,
        taxEnterpriseCodeList,
        keywordq,
        beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
        endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
      };
      exportPersonalTaxList(params);
    } catch (error) {
      message.error(error);
    }
  };
  const handlerChange = (dates, dateStrings) => {
    if (dates === null) {
      form.setFieldsValue({
        rangeDate: null,
      });
    }
  };
  const radioChange = (e) => {
    const startDate = moment()
      .subtract(e.target.value - 1, "days")
      .format("YYYY-MM-DD");
    const endDate = moment().format("YYYY-MM-DD");
    form.setFieldsValue({
      rangeDate: [moment(startDate), moment(endDate)],
    });
  };
  // 列表字段
  const tableColumns = [
    {
      title: "结算确认时间",
      dataIndex: "paymentTime",
      key: "paymentTime",
      width: 180,
      align: "center",
    },
    {
      title: "结算企业",
      dataIndex: "taxEnterpriseName",
      key: "taxEnterpriseName",
      width: 300,
      align: "center",
    },
    {
      title: "企业名称",
      dataIndex: "companyName",
      key: "companyName",
      width: 280,
      align: "center",
    },
    {
      title: "姓名",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "身份证号",
      dataIndex: "idNumber",
      key: "idNumber",
      width: 180,
      align: "center",
    },
    {
      title: "应发佣金",
      dataIndex: "amount",
      key: "amount",
      align: "center",
    },
    {
      title: "当期个税",
      dataIndex: "billTax",
      key: "billTax",
      align: "center",
    },
    {
      title: "实发佣金",
      dataIndex: "actualAmount",
      key: "actualAmount",
      align: "center",
    },
  ];
  return (
    <div>
      <Form form={form} {...labelStyleObj} labelAlign="left">
        <Row>
          <Form.Item label="时间" name="rangeDate">
            <RangePicker
              allowClear
              format={"YYYY-MM-DD"}
              onChange={handlerChange}
            />
          </Form.Item>
          <Form.Item style={{ width: "600px", marginLeft: "15px" }}>
            <Radio.Group onChange={radioChange}>
              <Radio value={1}>今天</Radio>
              <Radio value={7}>近7天</Radio>
              <Radio value={30}>近30天</Radio>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Row>
          <Form.Item label="企业名称" name="companyCodeList" style={itemStyle}>
            <Select
              allowClear
              placeholder="全部"
              showSearch
              optionFilterProp="children"
            >
              {companyCodeList.map((e) => (
                <Option key={e.companyCode} value={e.companyCode}>
                  {e.companyName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="结算企业"
            name="taxEnterpriseCodeList"
            style={itemStyle}
          >
            <Select
              allowClear
              placeholder="全部"
              showSearch
              optionFilterProp="children"
            >
              {taxEnterpriseCodeList.map((e) => (
                <Option key={e.code} value={e.code}>
                  {e.enterpriseName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item style={itemStyle} name="keyword" label="关键字">
            <Input placeholder="姓名丨身份证号丨手机号 | 所在城市" />
          </Form.Item>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={submit}
              style={{ marginRight: "15px" }}
            >
              查询
            </Button>
            <Button onClick={resetForm}>重置</Button>
            <Button
              type="primary"
              style={{ marginLeft: "15px" }}
              onClick={exportExcel}
            >
              导出
            </Button>
          </Col>
        </Row>
      </Form>
      <Table
        columns={tableColumns}
        dataSource={tableData}
        pagination={pagination}
        onChange={handleTableChange}
        bordered
        size="middle"
        loading={loading}
        rowKey={(record) => record.id}
      />
    </div>
  );
};

export default Current;
